const makeCancellable = (promise) => {
  let hasCancelled = false;

  const wrappedPromise = new Promise((resolve, reject) => {
    promise.then(
      (val) => (hasCancelled ? reject({ isCanceled: true }) : resolve(val)),
      (error) => (hasCancelled ? reject({ isCanceled: true }) : reject(error))
    );
  });

  return {
    promise: wrappedPromise,
    cancel() {
      hasCancelled = true;
    },
  };
};

export default makeCancellable;
